import React from "react";
import { useHistory } from "react-router";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { Typography, Link, MenuItem } from "@material-ui/core";
import {
  StyledLanguagesDropdown,
  StyledLanguageDropdownFlag,
} from "../../layout/elements";
import { footerRoutes } from "../../config";
import useScreen from "../../hooks/useScreen";
import useLanguage from "../../hooks/useLanguage";
import { SUPPORTED_LANGUAGES } from "../../constants";
import { translations } from "./translations";
const images = require.context("../../assets/flags", true);

const StyledFooterWrapper = styled.div`
  ${({ theme: { colors }, desktop }) => `
    background-color: ${colors.darkGray};
    width: 100%;
    display: flex;
    flex-direction: ${desktop ? "row" : "column"};
    justify-content: space-between;
    align-items: center;
    padding: 30px 24px;
    height: ${desktop ? "85px" : "150px"};
  `}
`;

const StyledLinksWrapper = styled.div`
  ${({ desktop }) => `
    display: flex;
    align-items: center;
    margin-bottom: ${desktop ? "0" : "30px"};
  `}
`;

const StyledCopyrightWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLink = styled(Link)`
  ${({ theme: { colors }, themecolor, desktop }) => `
    color: ${colors[themecolor]};
    font-size: ${desktop ? "16px" : "14px"};
    margin-right: 20px;
  `}
`;

const StyledText = styled(Typography)`
  ${({ theme: { colors } }) => `
    color: ${colors.white};
    white-space: nowrap;
  `}
`;

const Footer = () => {
  const history = useHistory();
  const [language, setLanguage] = useLanguage();
  const { desktop } = useScreen();
  const { formatMessage } = useIntl();

  const defaultLanguageValue = SUPPORTED_LANGUAGES.find(
    (l) => l.code === language
  ).code;

  const handleChangeLanguage = (e) => {
    const val = e.target.value;
    setLanguage(val);
    window.location.reload();
  };

  return (
    <StyledFooterWrapper desktop={desktop}>
      {/* Links */}
      <StyledLinksWrapper desktop={desktop}>
        {footerRoutes.map((route) => (
          <StyledLink
            desktop={desktop ? 1 : 0}
            key={route.id}
            themecolor="white"
            onClick={() => history.push(`${route.to}`)}
          >
            {formatMessage({
              id: `FOOTER.ROUTE.${route.text.toUpperCase()}`,
              defaultMessage: "",
            })}
          </StyledLink>
        ))}
        <StyledLanguagesDropdown
          disableUnderline
          labelId="language"
          aria-label="Language select"
          id="language"
          value={defaultLanguageValue}
          onChange={handleChangeLanguage}
          label="Language"
        >
          {SUPPORTED_LANGUAGES.map((option, index) => (
            <MenuItem key={index} value={option.code}>
              <StyledLanguageDropdownFlag
                desktop={desktop ? 1 : 0}
                imgSrc={images(`./${option.code}.png`)}
              />
            </MenuItem>
          ))}
        </StyledLanguagesDropdown>
      </StyledLinksWrapper>
      {/* Copiright */}
      <StyledCopyrightWrapper>
        <StyledText variant="body2">
          {formatMessage(translations.rights)} <br />
          <StyledLink
            themecolor="yellow"
            href="https://www.dundja-dev.com"
            target="_blank"
            rel="noopener"
          >
            {formatMessage(translations.builtBy)}
          </StyledLink>
        </StyledText>
      </StyledCopyrightWrapper>
    </StyledFooterWrapper>
  );
};

export default Footer;
